<template>
    <rect-btn
        shadow-color="rgba(171, 203, 216, 0.5)"
        background-color="#ffffff"
        font-size="1.5em"
        width="60px"
        height="60px"
        class="back-button"
        @click="back"
    >
        <img src="@/assets/back.png" alt="" width="70%" />
    </rect-btn>
</template>
<script>
export default {
    props: {
        preventDefault: Boolean,
    },
    methods: {
        back() {
            if (this.preventDefault) this.$emit('click');
            else this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.back-button {
    position: absolute;
    left: 0;
    top: 0;
    margin-left: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    z-index: 100;
    img {
        display: block;
        margin: auto;
    }
    @media screen and (max-width: 320px) {
        margin-left: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
</style>
